var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLocalhost)?_c('div',{staticClass:"alert alert-warning rounded-0 w-100",attrs:{"role":"alert"}},[_vm._v(" Você está em ambiente de desenvolvimento ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }